import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdeasService {

  private rootUrl = '';

  constructor(
    private http: HttpClient,
  ) {
      this.rootUrl = environment.ideasRootUrl;

  }

  getIdeasPageUri(uri: string): Observable<any> {
    if (!environment.cmsEnabled) {
      console.warn('CMS is disabled: getIdeasPageUri returning empty response');
      return of({ content: {} });
    }
    return this.http.get(this.rootUrl + '/site/api-rde' + uri);
  }

  getCategories(): Observable<any> {
    if (!environment.cmsEnabled) {
      console.warn('CMS is disabled: getCategories returning empty response');
      return of({ content: [] });
    }
    return this.http.get(this.rootUrl + '/site/api-rde/ideas/categories');
  }
}
